"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorSelectList = exports.CSS = void 0;
const core_api_1 = require("@ikegps/core-api");
const image_button_1 = require("../../../components/button/image.button");
const icons_1 = require("../../../components/icon/icons");
const input_1 = require("../../../components/input/input");
const input_state_1 = require("../../../components/input/input.state");
const theme_1 = require("../../../components/theme");
const i18n_1 = require("../../../i18n");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const classnames_1 = require("../../../util/classnames");
const form_field_editor_1 = require("./form.field.editor");
exports.CSS = {
    container: 'c-FdcSelectList',
    title: 'c-FdcSelectList__title',
    list: 'c-FdcSelectList__list',
    option: 'c-FdcSelectList__option',
    value: 'c-FdcSelectList__value',
    ghost: 'c-FdcSelectList__ghost',
    color: 'c-FdcSelectList__color',
    colorTitle: 'c-FdcSelectList__colorTitle',
};
const inputHeight = 32;
const colorPickerHeight = 24;
const colorPickerWidth = 32;
const colorPickerMargin = 20;
const keyInputWidth = 320;
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        width: '100%',
        display: 'flex',
        'flex-direction': 'column',
    },
    [exports.CSS.list]: {
        display: 'flex',
        width: '100%',
        'align-items': 'center',
        padding: theme_1.DefaultTheme.space(2),
    },
    [exports.CSS.option]: {
        width: `${keyInputWidth}px`,
        height: `${inputHeight}px`,
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        paddingRight: '12px',
    },
    [exports.CSS.ghost]: {
        color: theme_1.DefaultTheme.font.color.supporting,
    },
    [exports.CSS.value]: {
        width: `${keyInputWidth}px`, // TODO this is from the input width
        height: `${inputHeight}px`,
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        paddingRight: '12px',
    },
    [exports.CSS.colorTitle]: {
        width: `${colorPickerWidth}px`,
        marginRight: `${colorPickerMargin}px`,
        [`& + .${exports.CSS.option}`]: {
            width: `${keyInputWidth - colorPickerWidth - colorPickerMargin}px`,
        },
    },
    [exports.CSS.title]: {
        'font-weight': 'bold',
        'margin-bottom': theme_1.DefaultTheme.space(1),
        color: theme_1.DefaultTheme.font.color.supporting,
        height: '20px',
    },
    [exports.CSS.color]: {
        width: `${colorPickerWidth}px`,
        height: `${colorPickerHeight}px`,
        overflow: 'hidden',
        boxSizing: 'border-box',
        borderRadius: '4px',
        border: '2px solid #c9c9c9',
        marginRight: `${colorPickerMargin}px`,
        ['& input[type=color]']: {
            width: 'calc(100% + 12px)',
            height: 'calc(100% + 12px)',
            padding: 0,
            margin: '-6px',
            cursor: 'pointer',
        },
        [`& + .${exports.CSS.option}`]: {
            width: `${keyInputWidth - colorPickerWidth - colorPickerMargin}px`,
            [`& .mdl-textfield`]: {
                width: `calc(300px - ${colorPickerWidth + colorPickerMargin}px)`,
            },
        },
    },
});
function setterListValue(field, type, index) {
    return function (val) {
        let { text, value, color } = index < field.options.length ? field.options[index] : { text: '', value: String(index), color: '#a0aec0' };
        if (type === 'text') {
            field.Mutator.option({ text: val, value, color }, index);
        }
        else if (type === 'value') {
            field.Mutator.option({ text, value: val, color }, index);
        }
        else if (type === 'color') {
            field.Mutator.option({ text, value, color: val }, index);
        }
    };
}
class FormFieldEditorSelectList extends form_field_editor_1.FormFieldEditor {
    constructor() {
        super(...arguments);
        this.isAnalyst = services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
    }
    viewInfoRW() {
        const children = [this.viewOptionTitle()];
        for (let index = 0; index < this.field.options.length; index++) {
            const thisOption = this.field.options[index];
            const textState = this.getInputState('text', index);
            const valueState = this.getInputState('value', index, undefined, undefined, thisOption === null || thisOption === void 0 ? void 0 : thisOption.valueReadOnly);
            const colorState = this.getInputState('color', index);
            const isDeletableOption = (thisOption === null || thisOption === void 0 ? void 0 : thisOption.isDeletableOption) && index > 0;
            const node = (0, mithril_1.m)('div', { className: exports.CSS.list }, [
                ...this.viewSelectListOption(input_1.Input.view(textState), input_1.Input.view(valueState), services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) && this.field.isMapColorField
                    ? input_1.Input.view(colorState, { rawInputOnly: true })
                    : null),
                isDeletableOption ? this.viewOptionDeleteButton(index) : null,
            ]);
            children.push(node);
        }
        if (!this.field.isLocked || this.isAnalyst) {
            children.push(this.viewNewSelectListOption());
        }
        return (0, mithril_1.m)('div', { className: exports.CSS.container }, children);
    }
    viewOptionTitle() {
        const titleArr = [];
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) && this.field.isMapColorField) {
            titleArr.push((0, mithril_1.m)('div', { className: (0, classnames_1.classNames)(exports.CSS.title, exports.CSS.colorTitle) }, (0, i18n_1.Translate)(i18n_1.T.COLOR)));
        }
        titleArr.push((0, mithril_1.m)('div', { className: (0, classnames_1.classNames)(exports.CSS.title, exports.CSS.option) }, (0, i18n_1.Translate)(i18n_1.T.SELECT_LIST_TITLE)), (0, mithril_1.m)('div', { className: (0, classnames_1.classNames)(exports.CSS.title, exports.CSS.value) }, (0, i18n_1.Translate)(i18n_1.T.SELECT_LIST_VALUE)));
        return (0, mithril_1.m)('div', { className: exports.CSS.list }, titleArr);
    }
    viewSelectListOption(key, value, color) {
        return [
            services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) && this.field.isMapColorField
                ? (0, mithril_1.m)('div', { className: exports.CSS.color }, color)
                : null,
            (0, mithril_1.m)('div', { className: exports.CSS.option }, key),
            (0, mithril_1.m)('div', { className: exports.CSS.value }, value),
        ];
    }
    viewNewSelectListOption() {
        const index = this.field.options.length;
        const textState = this.getInputState('text', index, `${(0, i18n_1.Translate)(i18n_1.T.SELECT_LIST_TITLE)} ${index}`);
        const defaultValue = `${(0, i18n_1.Translate)(i18n_1.T.SELECT_LIST_VALUE)} ${index}`;
        const valueState = this.getInputState('value', index, defaultValue);
        const colorState = this.getInputState('color', index, '', '#a0aec0');
        return (0, mithril_1.m)('div', { className: exports.CSS.list }, [
            services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) && this.field.isMapColorField
                ? (0, mithril_1.m)('div', { className: `${exports.CSS.color} ${exports.CSS.ghost}` }, input_1.Input.view(colorState, { rawInputOnly: true }))
                : null,
            (0, mithril_1.m)('div', { className: `${exports.CSS.option} ${exports.CSS.ghost}` }, input_1.Input.view(textState)),
            (0, mithril_1.m)('div', { className: `${exports.CSS.value} ${exports.CSS.ghost}` }, input_1.Input.view(valueState)),
        ]);
    }
    viewOptionDeleteButton(index) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.DELETE, {
            onclick: () => {
                this.field.Mutator.remove(index);
                this.state.clearStates();
            },
        });
    }
    getInputState(type, index, placeholder, value, readOnly) {
        const fieldKey = `${index}:${type}`;
        let editState = this.state.get(fieldKey);
        if (editState == null) {
            editState = this.state.child(i18n_1.T.EMPTY, fieldKey, type === 'color' ? input_state_1.InputStateTypes.COLOR : input_state_1.InputStateTypes.TEXT);
            editState.onValue(setterListValue(this.field, type, index));
            if (placeholder != null) {
                editState.setPlaceholder(placeholder);
            }
            if (value != null) {
                editState.setValue(value);
            }
            else if (index < this.field.options.length) {
                editState.setValue(this.field.options[index][type]);
            }
            if ((index === 0 && type === 'value') || readOnly) {
                editState.setDisabled(true);
            }
            if (this.field.isLocked && !this.isAnalyst) {
                editState.setDisabled(true);
            }
        }
        editState.isRequired = type !== 'color' ? placeholder == null : false;
        return editState;
    }
}
exports.FormFieldEditorSelectList = FormFieldEditorSelectList;
//# sourceMappingURL=form.field.editor.select.list.js.map